import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIt = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 3 2", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#008C45", d: "M0 0h1v2H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M1 0h1v2H1z" }), /* @__PURE__ */ React.createElement("path", { fill: "#CD212A", d: "M2 0h1v2H2z" }));
const ForwardRef = forwardRef(SvgIt);
const Memo = memo(ForwardRef);
export default Memo;
